import { render } from "./IdenticalFormulationItem.vue?vue&type=template&id=ddc1ea28"
import script from "./IdenticalFormulationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IdenticalFormulationItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/IdenticalFormulationItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddc1ea28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddc1ea28', __exports__)) {
    console.log('reload')
    api.reload('ddc1ea28', __exports__)
  }
  
  module.hot.accept("./IdenticalFormulationItem.vue?vue&type=template&id=ddc1ea28", () => {
    console.log('re-render')
    api.rerender('ddc1ea28', render)
  })

}


export default __exports__